module.exports = function (app, mod) {
  return "\n  <div class='saito-announcement saito-sidebar-element'>The Saito Arcade is an online hub for the peer-to-peer games, web3, and video apps that run on Saito. Play any game to automatically join the leaderboard!</div>\n  <div class=\"arcade-invite\">\n  </div>";
};